/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { shape, bool } from "prop-types";

import { selectors as transactionsSelectors } from "reducers/transactions";
import { withMultipleSignaturesContext } from "pages/transactions/MultipleSignaturesTables/MultipleSignaturesDataContext";
import * as i18n from "util/i18n";

import { Tag } from "@ui-kit/components/index.es";

import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import CardContainer from "pages/_components/Card/CardContainer";
import Card from "pages/_components/Card/Card";

class TemporaryLimitIncreaseDataTable extends Component {
    static propTypes = {
        multipleSignaturesData: shape({}).isRequired,
        isDesktop: bool.isRequired,
    };

    getReasonLabel = (reason) => {
        if (!reason) {
            return "";
        }
        const key = `caps.reason.${reason}`;
        return i18n.get(key, reason);
    };

    getLimitQuantity = (temporaryLimit) => {
        if (temporaryLimit === undefined || temporaryLimit === null || temporaryLimit === "") {
            return 0;
        }
        const n = Number(temporaryLimit);
        return Number.isFinite(n) ? n : 0;
    };

    dataRow = () => {
        const { multipleSignaturesData, isDesktop } = this.props;
        const { selectedTransactionRows } = multipleSignaturesData;

        return selectedTransactionRows.map((object, index) => {
            const { transaction } = object;
            const { idTransaction, data = {}, submitDateTimeAsString } = transaction;
            const { duration, reason, temporaryLimit } = data;
            const reasonLabel = this.getReasonLabel(reason);
            const limitQty = this.getLimitQuantity(temporaryLimit);
            const currencyCode = data.currency !== undefined && data.currency !== null ? String(data.currency) : "0";

            const renderReason = () => (
                <div className="temporary-limit-increase-card__motivo-row">
                    <div className="temporary-limit-increase-card__first-line">
                        <span className="temporary-limit-increase-card__motivo-label">
                            <I18n id="multipleSignatures.temporaryLimitIncrease.motivoLabel" />
                        </span>
                        <span className="temporary-limit-increase-card__reason">{reasonLabel}</span>
                        <Tag variant="info" className="temporary-limit-increase-card__limit-tag">
                            <I18n id="multipleSignatures.temporaryLimitIncrease.badgePrefix" />{" "}
                            <FormattedAmount quantity={limitQty} currency={currencyCode} notBold />
                        </Tag>
                    </div>
                    <div className="temporary-limit-increase-card__vigencia">
                        <span className="temporary-limit-increase-card__label">
                            <I18n id="multipleSignatures.temporaryLimitIncrease.vigenciaLabel" />
                        </span>{" "}
                        <span className="temporary-limit-increase-card__vigencia-value">{duration}h</span>
                    </div>
                </div>
            );

            return (
                <CardContainer
                    key={idTransaction || `temporary-limit-${index}`}
                    className="confirmation__cards-container mt-0">
                    <Card
                        isDesktop={isDesktop}
                        className="confirmation__cards temporary-limit-increase-card"
                        icon={isDesktop && "images/transfer-PENDING.svg"}
                        iconClass="card__pending-transaction-icon"
                        hrClass="d-none"
                        title={
                            !isDesktop && (
                                <div>
                                    {submitDateTimeAsString && (
                                        <div className="confirmation-cards__title">
                                            <div className="confirmation-cards__title-data">
                                                <I18n id="forms.transaction.ticket.date" />
                                            </div>
                                            <div className="confirmation-cards__title-info">
                                                <span>{submitDateTimeAsString}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }
                        content={isDesktop ? renderReason() : <div>{renderReason()}</div>}
                    />
                </CardContainer>
            );
        });
    };

    render() {
        return this.dataRow();
    }
}

const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
});

export default connect(mapStateToProps)(withMultipleSignaturesContext(TemporaryLimitIncreaseDataTable));
